import React, {useEffect, useState} from "react";
import "./SendManagementCurrent.sass";
import "../ManagementHistoryCard/ManagementHistoryCard.scss"
import {ManagementCurrentCard} from "../ManagementCurrentCard/ManagementCurrentCard";
import {courierManagerArchivedOrders_api, courierManagerOrders_api} from "../SendManagementService";

function SendManagementCurrent({data}) {

    const [currents , set_currents ] = useState([])


    useEffect(()=>{
        console.log("data YYYY : ",data)
        set_currents(data)
    },[data])

    const HandleScrollListener = async () =>{
        const doc = document.documentElement;
        let calc = doc.scrollHeight -(doc.scrollTop + doc.clientHeight)
        let cond = calc>3 || calc<-3
        if(!cond) {
            console.log("bottonnnnn current");
            pageinate()
        }
    }

    useEffect(()=>{
        //handle scroll arrived to Top
        window.currentPage = 1;
        window.addEventListener('scroll',HandleScrollListener);
        return () => {
            window.removeEventListener('scroll', HandleScrollListener); // Remove Scroll Event Listener
        };
    },[])

    const pageinate = async ()=>{
        window.currentPage = window.currentPage+1;
        try{
            const response = await courierManagerOrders_api(window.currentPage);
            set_currents((list)=>[...list,...response.data.results]);
        }catch (e) {
            console.log(e);
        }
    }

    useEffect(()=>{

    })

    return(
        <div>
            {currents.length>0?<>
                {currents.map(item=>{
                    return(
                        <ManagementCurrentCard it={item}/>
                    )
                })}
            </>:
                <div className="empty-list">
                <i className="fa fa-database"></i>
                <span>سفارشی در لیست وجود ندارد</span>
            </div>
            }

        </div>
    )

}

export {SendManagementCurrent};
